<script setup>
import {computed} from 'vue'
import ListingNoContent from './ListingNoContent.vue'
import ListingNoContentOptions from './ListingNoContentOptions.vue'
import GridViewThumbnail from './GridViewThumbnail.vue'
import {useLightboxStore} from '@/stores/lightbox'
import {useViewStore} from '@/stores/view'

// Import local directive
import vDisableShiftSelect from '@/vue/directives/disableShiftSelect'

const props = defineProps({
    viewId: {
        type: String,
        required: true
    }
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Pinia Store
const lightboxStore = useLightboxStore()

// --- Computed Properties ---
const listingName = computed(() => viewStore.listingName)
const tableName = computed(() => viewStore.tableName)
const itemCount = computed(() => viewStore.itemCount || 0)
const ids = computed(() => viewStore.ids || [])

// --- Initialization ---
lightboxStore.reset()
</script>

<template>
    <div v-disable-shift-select>
        <template v-if="itemCount === 0">
            <ListingNoContent :view-id="viewId"/>
            <ListingNoContentOptions :view-id="viewId"/>
        </template>

        <div v-if="itemCount > 0" class="row g-3">
            <div v-for="id in ids" :key="id" class="col-xs-6 col-sm-3 col-md-2 col-lg-2">
                <GridViewThumbnail :id="id" :view-id="viewId"/>
            </div>
        </div>
    </div>
</template>